module.exports = __webpack_public_path__ + "img/SPC_Sword3 Clean OneMaterial.20d366e7.png";